import * as React from 'react';
import { Rifm } from 'rifm';
import { Input } from '../input/newInput/NewInput';
import { formatPhone } from '../rifmRecipes/phone';

export interface IPhoneNumberProps {
  onChange: (value: string, name: string) => void;
  value: string;
  name: string;
  className?: string;
  placeholder: string;
  stretch?: boolean;
  disabled?: boolean;
  dataAt?: string;
  dataTestId?: string;
  error?: string;
  label?: string;
  id?: string;
  onSubmit?: () => void;
  withNumericMobileKeyboard?: boolean;
}

export interface IPhoneNumberState {
  phoneNumber: string;
}

export class PhoneNumber extends React.Component<IPhoneNumberProps> {
  public static defaultProps = {
    value: '',
    stretch: false,
    placeholder: 'Enter mobile number',
    disabled: false,
  };

  public static getDerivedStateFromProps(nextProps: IPhoneNumberProps /* , prevState: IPhoneNumberState */) {
    return {
      phoneNumber: formatPhone(nextProps.value),
    };
  }

  public state = {
    phoneNumber: '',
  };

  public componentDidMount() {
    this.setState(() => ({ phoneNumber: formatPhone(this.props.value || '') }));
  }

  private handleOnChange = (value: string): void => {
    this.setState(() => ({ phoneNumber: value }));
    this.props.onChange(value.replace(/[^\d]+/gi, ''), this.props.name);
  };

  public render() {
    const { phoneNumber } = this.state;
    return (
      <Rifm
        accept={/\d+/g}
        // do not jump after ) until see number before
        mask={phoneNumber.length < 6 && /[^\d]+/.test(phoneNumber[3]) ? undefined : phoneNumber.length >= 14}
        format={formatPhone}
        value={phoneNumber}
        onChange={this.handleOnChange}
      >
        {({ value, onChange }: { value: string; onChange: any }) => (
          <Input
            {...{ ...this.props, onChange, value }}
            inputMode={this.props.withNumericMobileKeyboard ? 'numeric' : undefined}
            label={this.props.label || ''}
            dataAt={this.props.dataAt || ''}
            dataTestId={this.props.dataTestId || ''}
          />
        )}
      </Rifm>
    );
  }
}
